import template from './riskInsuranceRequirementsApplicants.template.html';

export default {
  template,
  bindings: {
    applicants: '<',
    contacts: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($mdMedia, helperService) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.availableYesNoOptionsThree = [];
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.applicants = ctrl.applicants || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.availableYesNoOptionsThree = helperService.getAvailableYesNoOptions({
          option: 4
        });
        ctrl.isDisabled = ctrl.isDisabled || false;
        ctrl.isReady = true;
      };

      ctrl.getContactName = (idContact) => {
        const contact = _.find(ctrl.contacts || [], (c) => c?.id === idContact);
        return contact?.getName() || 'N/A';
      };

      ctrl.saveRiskInsuranceRequirementsApplicant = (item) => {
        if (item) {
          const idx = _.findIndex(
            ctrl.applicants || [],
            (a) => a?.idContact === item?.idContact
          );
          if (idx > -1) {
            ctrl.applicants.splice(idx, 1);
            ctrl.applicants.splice(idx, 0, item);
          } else {
            ctrl.applicants.push(item);
          }
        }
        ctrl.onFinished({ applicants: ctrl.applicants });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
